.statusBoxes {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
